// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"278":"a478e5bd","329":"13c04857","389":"13300c3a","453":"5e607b32"}[chunkId] + ".chunk.js";
};